import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { History } from 'history'; // eslint-disable-line

import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { startAuthRefresh as serviceStartAuthRefresh } from '../../lib/store/auth';
import { login as serviceLogin, logout as serviceLogout } from '../../lib/store/common-actions';
import { isMyPortalTrade } from '../../lib/util/auth/helpers';

import ArrowBack from '../../assets/img/blue_icon-arrow-left.svg';
import SearchIconMobile from '../../assets/img/icon-search_24px.svg';
import SearchIcon from '../../assets/img/icon-search_white.svg';
import profileImage from '../../assets/img/profile.svg';
import { MOCK } from '../../configDebug';
import { useIsMobile } from '../../hooks';
import { getTabName } from '../../util/helpers';
import { UI_ROUTES } from '../../util/routes';
import { ClickableImage, Sidebar } from '../index';
import WelcomeSubscriptionPopup from '../WelcomeSubscriptionPopup/WelcomeSubscriptionPopup';

import HeaderDropdown from './HeaderDropdown/HeaderDropdown';
import { LogoutActionSelector, RefreshActionSelector } from './HeaderConstants';
import TestHeader from './TestHeader';

import styles from './Header.module.scss';

type OwnProps = {
  isSearchActive: (val: boolean) => void;
};
type Props = OwnProps & ReduxProps;

const Header = (props: Props): JSX.Element => (
  <>
    {MOCK.TEST_HEADER && <TestHeader {...props} />}
    <HeaderOriginal {...props} />
  </>
);

const HeaderOriginal = (props: Props) => {
  const { startAuthRefresh, bonusAccounts, logout, login, isSearchActive } = props;
  const isMobile = useIsMobile();
  const location = useLocation();
  const history = useHistory();

  const isShowSearchIcon = [
    UI_ROUTES.earningsCalendar,
    UI_ROUTES.overview,
    UI_ROUTES.discover,
    UI_ROUTES.myAccount,
    UI_ROUTES.myProfile,
    UI_ROUTES.myPosition,
    UI_ROUTES.tradeHistory,
  ].includes(location.pathname);

  const handleGoBack = () => {
    history.goBack();
  };

  const handleLogout = () => {
    logout();
    if (!isMyPortalTrade()) {
      login(history);
    }
  };

  const returnBtn = () => (
    <button type="button" className={styles.returnBtn} onClick={handleGoBack}>
      <img src={ArrowBack} alt="Back" />
    </button>
  );

  const onSearchClickWeb = (): void => {
    isSearchActive(true);
  };

  const onSearchClickMob = () => {
    history.push(`${UI_ROUTES.searchSymbolsMob}`);
  };

  const handleHamburgerMenu = () => (
    <>
      <Sidebar isCapitalHamburger />
    </>
  );

  return (
    <>
      {isMobile ? (
        <div className={classNames(styles.containerMobile, {
          [styles.containerMobileCapital]: true,
        })}
        >
          <div className={styles.returnBtnMobile}>
            {getTabName(location) === 0 ? returnBtn() : handleHamburgerMenu()}
          </div>
          <div>
            <WelcomeSubscriptionPopup />
          </div>
          {isShowSearchIcon && (
            <div className={styles.buttonsMobile}>
              <div className={styles.searchBtnMobile}>
                <ClickableImage
                  src={SearchIconMobile}
                  alt="search"
                  className={styles.searchIcon}
                  onClick={onSearchClickMob}
                />
              </div>
              <div className={styles.notificationsMobile}>
                <HeaderDropdown isUserProfile={false} />
              </div>
              {isMyPortalTrade() && (
                <ClickableImage
                  className={styles.searchBtnMobile}
                  src={profileImage}
                  alt="search"
                  onClick={() => {
                    history.push(UI_ROUTES.myProfile);
                  }}
                />
              )}
            </div>
          )}
        </div>

      ) : (
        <>
          <div className={styles.container}>
            <div className={styles.contentWrapper}>
              <div className={styles.headerElements}>
                <div className={styles.headerProfileInfo}>
                  <div className={styles.settings}>
                    <HeaderDropdown isUserProfile={false} />
                  </div>
                  <div className={styles.userData}>
                    <HeaderDropdown
                      isUserProfile
                      actions={{
                        [LogoutActionSelector]: handleLogout,
                        [RefreshActionSelector]: startAuthRefresh,
                      }}
                    />
                  </div>
                </div>
                <div className={styles.searchStocksWrapper}>
                  <img src={SearchIcon} alt="search stocks" />
                  <input type="text" readOnly placeholder={lang.commonSearchForStocks()} onClick={onSearchClickWeb} />
                </div>
              </div>
              <div className={styles.hiddenHeader} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  bonusAccounts: state.crm.bonusAccounts,
});

const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  dispatch,
  startAuthRefresh: () => dispatch(serviceStartAuthRefresh()),
  logout: () => dispatch(serviceLogout()),
  login: (history: History) => {
    dispatch(serviceLogin('login'));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Header);
